<script lang="ts" setup>
const route = useRoute();
const { t } = useI18n();
useHead({
  title:
    route.params.action === "buy"
      ? t("p-trade-action-buy-title")
      : t("p-trade-action-sell-title"),
  meta: [
    {
      name: "description",
      content:
        route.params.action === "buy"
          ? t("p-trade-action-buy-description")
          : t("p-trade-action-sell-description"),
    },
    {
      name: "keywords",
      content:
        route.params.action === "buy"
          ? t("p-trade-action-buy-keywords")
          : t("p-trade-action-sell-keywords"),
    },
  ],
});
definePageMeta({ auth: false });
const OffersStore = useOffersStore();
const { offers, loading } = storeToRefs(OffersStore);
const CurrencyStore = useCurrencyStore();
const { getAvailablePairs } = CurrencyStore;
const router = useRouter();
function isOfTypeActions(keyInput: string) {
  return ["buy", "sell", "my-offers", "orders", "profile"].includes(keyInput);
}
if (!isOfTypeActions(route.params.action as string)) {
  router.replace("/trade/buy");
}
const filtersSelected = inject("filtersSelected");
const emit = defineEmits(["clearFilters"]);
onBeforeMount(() => {
  getAvailablePairs();
});
</script>

<template>
  <div class="action-cont">
    <div v-if="loading">
      <el-skeleton :rows="3" animated />
      <el-divider />
      <el-skeleton :rows="3" animated />
    </div>
    <OffersTable
      v-else-if="offers.length"
      :offers="offers"
      :showControls="{ createOrder: true }"
    />
    <el-empty v-else :description="t('p-trade-action-nothing-found')">
      <el-button
        round
        v-if="filtersSelected"
        type="primary"
        @click="emit('clearFilters')"
      >
        {{ t("p-trade-action-clear-filters") }}
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="scss" scoped>
.action-cont {
  :deep(.el-scrollbar) {
    width: 100%;

    .el-scrollbar__view,
    .el-scrollbar__wrap {
      width: 100%;
    }
  }
}
</style>
